export const demoData = {
  advertisers: [
    {
      id: "adv_dyson",
      name: "Dyson",
      logo:
        "https://pbs.twimg.com/profile_images/3684938391/2b6b9ca4605f72236ee73247ee99d366_400x400.png",
      brands: [
        {
          id: "dyson-main",
          name: "Dyson",
          plans: [
            {
              id: "dyson-mobility-adres-demo",
              meta: {
                advertiser: "Dyson",
                brand: "Dyson",
                campaign: "Ekim 2023 Lansman Kampanyası",
                period: "Ekim 2023",
                notes: [
                  "Bu planın adresleri mobility dosyasındaki adreslerle birebir eşleşir."
                ],
                city: "İstanbul",
                startDate: "2023-10-01",
                endDate: "2023-10-31",
                totalBudget: 11000,
              },
              rows: [
                {

                  // Mobility dosyasındaki ilk satırlardan seçildi:
                  sites: [
                    {
                      city: "İstanbul",

                      id: "mob-1",
                      name: "Taşkışla Caddesi Hayat Otel Karşısı Maçka Yönü",
                      address:
                        "Taşkışla Caddesi Hayat Otel Karşısı Maçka Yönü",
                      periodCount: 1,
                      unit: "CLP",
                      type: "Media",
                      unitNumber: 4,
                      faces: 4,
                      unitPrice: 900,
                      vendor: "Clear",
                      budget: 3600,
                      baslangic: "21-10-2023",
                      bitis: "28-10-2023",
                      explanations: "Adres bazlı mobilite eşleştirme testi",

                    },
                    {
                      city: "İstanbul",

                      id: "mob-2",
                      name: "Harbiye Mahallesi Kadırgalar Caddesi 3. Raket",
                      address:
                        "Harbiye Mahallesi Kadırgalar Caddesi 3. Raket",
                      periodCount: 1,
                      unit: "Bilboard",
                      type: "Media",
                      unitNumber: 3,
                      faces: 3,
                      unitPrice: 800,
                      vendor: "Clear",
                      budget: 2400,
                      baslangic: "21-10-2023",
                      bitis: "28-10-2023",
                      explanations: "Adres bazlı mobilite eşleştirme testi",
                    },
                    {
                      city: "İstanbul",

                      id: "mob-3",
                      name:
                        "Göktürk İstanbul Caddesi 4. Raket Fidanlık Karşısı",
                      address:
                        "Göktürk İstanbul Caddesi 4. Raket Fidanlık Karşısı",
                      periodCount: 1,
                      unit: "CLP",
                      type: "Media",
                      unitNumber: 2,
                      faces: 2,
                      unitPrice: 700,
                      vendor: "Clear",
                      budget: 1400,
                      baslangic: "13-10-2023",
                      bitis: "20-10-2023",
                      explanations: "Adres bazlı mobilite eşleştirme testi",
                    },
                    {
                      city: "İstanbul",
                      id: "mob-4",
                      name: "Hakkı Yeten Cad. Orta Ada Selenium Karşısı",
                      address: "Hakkı Yeten Cad. Orta Ada Selenium Karşısı",
                      periodCount: 1,
                      unit: "Bilboard",
                      type: "Media",
                      unitNumber: 4,
                      faces: 4,
                      unitPrice: 900,
                      vendor: "Clear",
                      budget: 3600,
                      baslangic: "14-10-2023",
                      bitis: "21-10-2023",
                      explanations: "Adres bazlı mobilite eşleştirme testi",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
